import CampaignPromo from './CampaignPromo.view';

export default CampaignPromo;